export var apiUrl = process.env.API_URI;
export var sentryDsn = process.env.SENTRY_DSN;
var sampleRate = parseFloat(process.env.SENTRY_APM);
export var sentrySampleRate = isNaN(sampleRate) ? 0 : sampleRate;
export var serviceWorkerTimeout = parseInt(process.env.SERVICE_WORKER_TIMEOUT, 10) || 60 * 1000;
export var demoMode = process.env.DEMO_MODE === "true";